<template>
  <!-- testimonial -->
  <section class="text-center" id="temoignage">
    <h3 class="customHeader text-center h1">Temoignage</h3>
    <div class="info">
      <div class="container text-white">
        <carousel :dots="false" :items="1" :autoplay="true" :nav="false">
          <div class="item">
            <div class="media d-block d-md-flex">
              <img
                class="d-flex rounded-circle avatar z-depth-1-half mb-3 mx-auto"
                src="@/assets/image/ava1.png"
                style="width: 100px;"
                alt="Avatar"
              />
              <i class="fab fa-rocketchat fa-2x text-primary"></i>
              <div class="media-body text-center text-md-left ml-md-3 ml-0">
                <h5 class="mt-0 font-weight-bold blue-text">Person one</h5>
                <p>
                  <i
                    class="fa fa-quote-left"
                    aria-hidden="true"
                    style="position: absolute; top: 0; left: 0;"
                  ></i
                  >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Sequi atque consequuntur laboriosam, reiciendis nihil sit.<i
                    class="fa fa-quote-right"
                    style="position: absolute; bottom: 0; right: 0;"
                    aria-hidden="true"
                  ></i>
                </p>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="media d-block d-md-flex">
              <img
                class="d-flex rounded-circle avatar z-depth-1-half mb-3 mx-auto lazy"
                src="@/assets/image/ava2.jpg"
                style="width: 100px;"
                alt="Avatar"
              />
              <i class="fab fa-rocketchat fa-2x text-primary"></i>
              <div class="media-body text-center text-md-left ml-md-3 ml-0">
                <h5 class="mt-0 font-weight-bold blue-text">Person two</h5>
                <p>
                  <i
                    class="fa fa-quote-left"
                    aria-hidden="true"
                    style="position: absolute; top: 0; left: 0;"
                  ></i
                  >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Possimus debitis libero maiores at! Dignissimos,
                  praesentium.<i
                    class="fa fa-quote-right"
                    style="position: absolute; bottom: 0; right: 0;"
                    aria-hidden="true"
                  ></i>
                </p>
              </div>
            </div>
          </div>
        </carousel>
      </div>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  components: { carousel }
};
</script>

<style lang="scss">
.customHeader {
  font-weight: bold;
  color: #000098;
  text-align: center;
  padding: 70px 0 30px;
}

.customHeader:before {
  content: "";
  display: block;
  height: 8px;
  background: #000098;
  width: 75px;
  margin: auto;
  position: relative;
  top: 64px;
}
.customHeader:after {
  content: "";
  display: block;
  height: 5px;
  background: #000098;
  width: 185px;
  margin: auto;
  margin-top: 10px;
}

.info {
  background: url("../assets/image/koko.png") no-repeat center center;
  height: 600px;
  display: flex;
  align-items: center;
}
.info .avatar {
  width: 100px;
  margin: auto;
}
.info p {
  text-align: center;
  position: relative;
  padding: 20px;
}
.item .media {
  margin-top: 80px;
}
.owl-carousel.owl-loaded {
  display: block;
  transform: translateY(-70px);
}
</style>